angular.module('gym').config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('gym.event_defaults', {
    abstract: true,
    template: '<ui-view></ui-view>'
  }).state('gym.event_defaults.list', {
    url: '/calendar/event_defaults',
    template: require('templates/gyms/event_defaults/list.html.slim')
  });
}]);
